import {

	Blog2BlogImg1,
	Blog2BlogImg2,
	Blog2BlogImg3

} from '../../utils/allImgs'

export const dataBlog2 = [
	{
		img:Blog2BlogImg1,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"New and Creative NFTs Marketplace for All Digital Asset Needs.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog2BlogImg2,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Holly Herndon and Mat Dryhurst on the dreamy decentralized collaboration.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog2BlogImg3,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Rick Silva on the nature of a not-too-distant future.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog2BlogImg1,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"NFT’s smart contracts are verified and open source.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog2BlogImg2,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Manual Photo + Raven B. on picturing a whole new world.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog2BlogImg3,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Guest Blog: Gene Kogan on the art of credit assignment.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	}
]


export const dataDown = [
	{
		img:Blog2BlogImg1,
		title:"EU council reunites",
		text:"Nov 29, 2021"
	},
	{
		img:Blog2BlogImg2,
		title:"A new way to travel the world",
		text:"March 29, 2021"
	},
	{
		img:Blog2BlogImg3,
		title:"Why choose a bank?",
		text:"March 29, 2021"
	}
]


// export default data